import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class PincodeValidator {
    public static get validate(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors => {
            if (!control.value) {
                return null;
            }

            const areSequentialNumbers = PincodeValidator.areSequentialNumbers(control.value);
            const hasTooManyEqualNumbers = PincodeValidator.hasTooManyEqualNumbers(control.value);
            return areSequentialNumbers || hasTooManyEqualNumbers ? { pincode: true } : null;
        };
    }

    private static areSequentialNumbers(value: string): boolean {
        return '0123456789'.indexOf(value) > -1 || '9876543210'.indexOf(value) > -1;
    }

    private static hasTooManyEqualNumbers(value: string): boolean {
        return (
            +Object.values(
                value.split('').reduce((acc, element: string) => {
                    acc[element] = (acc[element] + 0 || 0) + 1;
                    return acc;
                }, {})
            )
                .sort((a: number, b: number) => a - b)
                .reverse()[0] >= 4
        );
    }
}
